// Adherence colour key for the Table view, next to the toggles. Mirrors
// CalendarLegend.js's structure, but carries an extra ⓘ: Table paints THREE
// things with three different rules (the date dot blends the whole day, the
// Consumed cells score each macro on its own and more strictly, and the
// Adherence column is a percentage score), while Calendar only ever paints
// the day. The labels used to spell out "off 10–25%", which are the dot's
// thresholds only — accurate for the dot, wrong for the cells sitting right
// next to it. The labels are now rule-agnostic and the ⓘ carries the detail.

import React from "react";
import { useTranslation } from "react-i18next";

import SvgIcon from "../../../../../parts/SvgIcon";
import ToolTip from "../../../../../parts/tooltip";
import { translateCalendarLegend, ADH_COLOR } from "./viewTokens";
import { SWATCH_ITEMS } from "./TableFormat";

const INFO_ICON = "/img/new-icons/question-circle.svg";

const tt = (t, key) => t(`nutritionPage.progress.table.${key}`);

export const TableLegend = () => {
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="np-table-toggles__legend">
      {SWATCH_ITEMS.map(({ key, token }) => (
        <span
          key={key}
          className="np-table-toggles__legend-item"
          style={{ color: ADH_COLOR[token].text }}
        >
          <span
            className="np-table-toggles__legend-swatch"
            style={{ background: ADH_COLOR[token].text }}
          />
          {translateCalendarLegend(t, key)}
        </span>
      ))}
      {/* One ToolTip instance for the whole legend (not one per swatch) —
          the wrapper mounts a ReactTooltip per usage, so keeping it at the
          legend level costs one node instead of four. tooltip-default-style
          is the app's standard explainer look and already sets
          white-space: pre-line, so the copy's own line breaks render
          without any HTML in the translation string. */}
      <ToolTip
        id="np-table-legend-info"
        body={tt(t, "legendInfoTooltip")}
        className="np-table-toggles__legend-info"
        hintClassNames="tooltip-default-style np-table-toggles__legend-tooltip"
      >
        <SvgIcon
          src={INFO_ICON}
          alt={tt(t, "legendInfoAlt")}
          className="cursor-pointer"
        />
      </ToolTip>
    </div>
  );
};

export default TableLegend;
